<script lang="ts" setup>
defineProps<{
  title: string
  description: string
  shadow?: boolean
}>()
</script>

<template>
  <div
    class="mx-auto flex h-[264px] w-[304px] flex-col items-center justify-between p-[24px]"
    :class="{ 'card-marketing-static': shadow }"
  >
    <slot name="icon" />
    <div class="mb-1 mt-[16px] font-primary text-[18px] font-medium leading-[28px] text-gray-1000">{{ title }}</div>
    <p class="mb-[16px] mt-[4px] text-[14px] leading-[20px] text-gray-700">
      {{ description }}
    </p>
    <slot />
  </div>
</template>
